// config/AuthApiEndpoints.js - Complete config file with all missing exports
// Import centralized API configuration
import { BASE_API, API_VERSION, API_BASE_URL } from './apiConfig';
// Re-export for backward compatibility
export { BASE_API, API_VERSION };
export const AUTH_API_BASE = `${API_BASE_URL}/auth`;
export const AUTH_ENDPOINTS = {
  BASE_URL: AUTH_API_BASE,
  // User Authentication
  REGISTER: `${AUTH_API_BASE}/register/user`,
  GENERATE_OTP: `${AUTH_API_BASE}/generate/otp`,
  LOGIN: `${AUTH_API_BASE}/login`,
  // Token refresh endpoint
  REFRESH: `${AUTH_API_BASE}/refresh`,
  // User Management
  GET_USER: `${AUTH_API_BASE}/users/email`,
  getUserByEmail: (email) => `${AUTH_API_BASE}/users/email/${email}`,
  getUserOrganizations: (email) => `${BASE_API}/${API_VERSION}/users/email/${email}/organizations`,
  // Organization Registration
  REGISTER_ORGANIZATION: `${AUTH_API_BASE}/register/organisation`,
  // Cognito/OAuth Callbacks
  COGNITO_CALLBACK: `${AUTH_API_BASE}/cognito/callback`,
  ACCEPT_INVITE: `${AUTH_API_BASE}/accept-invite`,
  // Domain-specific client endpoints
  DOMAIN_CLIENT: `${BASE_API}/api/domain-clients/domain-client`
};
// Cognito Configuration - ADDED MISSING EXPORT
export const COGNITO_CONFIG = {
  COGNITO_DOMAIN: 'eu-west-1kna8dt1up.auth.eu-west-1.amazoncognito.com',
  CUSTOM_DOMAIN: 'auth.dr.tonicsuite.io',
  IDENTITY_PROVIDERS: {
    MICROSOFT: 'TonicMicrosoftIdp',
    GOOGLE: 'Google'
  },
  DEFAULT_CLIENT_ID: '4khlsm17he92bc1llpvcqq31b0',
  DEFAULT_REDIRECT_URI: 'https://dr.tonicsuite.io/callback'
};
// Backward compatibility exports
export const RegisterUser = AUTH_ENDPOINTS.REGISTER;
export const GenerateOtp = AUTH_ENDPOINTS.GENERATE_OTP;
export const LoginWithOtp = AUTH_ENDPOINTS.LOGIN;